var STATE_DEFAULT = {
  loading: false,
  metadata: undefined
};
export var COUNTRY_METADATA_LOAD = 'COUNTRY_METADATA_LOAD';
export var COUNTRY_METADATA_UPDATE = 'COUNTRY_METADATA_UPDATE';
export default function countryMetadata() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case COUNTRY_METADATA_LOAD:
      return Object.assign({}, state, {
        loading: true
      });

    case COUNTRY_METADATA_UPDATE:
      return {
        loading: false,
        metadata: action.metadata
      };

    default:
      return state;
  }
}